import { useEffect } from 'react'
import { useWatch } from 'react-hook-form'
import { FieldValues } from 'react-hook-form/dist/types'

import { useSessionState } from 'context/Session'
import { useFlow, useFlowSlug } from 'utils/flow'
import { useLocalStorage, useSetIsDisabled } from 'utils/hook'
import { useAutoUnregister } from 'utils/useAutoUnregister'

export default function PersistWatch(): null {
  const values: FieldValues = useWatch()
  const { isSubmitted } = useSessionState()
  const { data: flowData } = useFlow()

  const flowSlug = useFlowSlug()
  const [, setLS] = useLocalStorage(`${flowSlug}/form`, {})

  useSetIsDisabled(values, flowData?.required_fields)
  useAutoUnregister()

  useEffect(() => {
    if (!isSubmitted) {
      setLS(values)
    }
  }, [values, isSubmitted])

  return null
}
